<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('out_of_country_request')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('out_of_country_request')"
                              :isFilter="false"/>
            </template>
            <b-container fluid="md">
                <b-row class="justify-content-center">
                    <b-col cols="12" md="8">
                        <b-card class="mt-4">
                            <ValidationObserver ref="formObserver">
                                <b-form @submit.prevent="onSubmit">
                                    <b-row>
                                        <b-col cols="12">
                                                <b-form-group
                                                    id="input-group-name"
                                                    :label="$t('full_name')"
                                                    label-for="input-name"
                                                >
                                                    <b-form-input
                                                        v-model="fullName"
                                                        id="input-name"
                                                        type="text"
                                                        readonly
                                                    ></b-form-input>
                                                </b-form-group>
                                        </b-col>

                                        <b-col cols="12">
                                            <b-form-group
                                                id="input-group-name"
                                                :label="$t('student_id')"
                                                label-for="input-name"
                                            >
                                                <b-form-input
                                                    id="input-name"
                                                    type="text"
                                                    v-model="form.student_number"
                                                    readonly
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12">
                                            <div class="label-as-input-div">
                                                <label>{{ $t('module_status') }}</label>
                                                <div>
                                                    {{ this.getObjectValue(form, 'module') }}
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" class="d-flex">
                                            <b-col cols="6" class="pr-0 pl-0">
                                                <ValidationProvider name="estimated_departure_date" rules="required" v-slot="{ valid, errors }">
                                                    <b-form-group
                                                        id="input-group-name"
                                                        :label="$t('estimated_date_of_departure')"
                                                        label-for="input-name"
                                                    >
                                                        <select-date :is-time="true"  v-model="form.estimated_departure_date" :validation-error="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="6" class="pr-0">
                                                <validation-provider name="estimated_return_date" rules="required" v-slot="{ valid, errors }">
                                                    <b-form-group
                                                        id="input-group-name"
                                                        :label="$t('estimated_date_of_return')"
                                                        label-for="input-name"
                                                    >
                                                        <select-date :is-time="true" v-model="form.estimated_return_date" :validation-error="errors[0]"/>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-col>
                                        <b-col cols="12">
                                            <validation-provider name="reason" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('reason')">
                                                    <b-form-textarea v-model="form.reason"
                                                                     :class="errors[0] ? 'is-invalid':''"
                                                                     rows="5"
                                                    />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col cols="12">
                                            <ValidationProvider name="selected_sessions"
                                                                rules="required"
                                                                v-slot="{ valid, errors }">
                                                    <b-form-checkbox
                                                        id="checkbox-1"
                                                        v-model="form.status"
                                                        name="checkbox-1"
                                                        value="accepted"
                                                        :unchecked-value="null"
                                                    >
                                                        Please wait until your request has been reviewed before purchasing your tickets. Having tickets does not indicate that your trip has been approved.
                                                    </b-form-checkbox>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                            </ValidationProvider>
                                            </b-col>
                                        <b-col cols="12" class="text-center mt-3">
                                            <LoadingButton
                                                :loading="isLoading"
                                                text="Save"
                                                @click="onSubmit"/>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </ValidationObserver>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";

export default {
    components: {
        MultiSelectbox,
        AppLayout,
        Header,
        LoadingButton,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            isLoading: false,
            form: {},
            selected_sessions:[]
        }
    },

    metaInfo() {
        return {
            title: this.$t('out_of_country_request')
        }
    },
    created() {
        this.getData();
    },
    computed:{
      fullName(){
          if (!this.form){
              return ''
          }
          return (this.form?.name??'') + " " + (this.form?.surname??'')
      },
    },
    methods: {
        async getData(){
            try {
                const res = await OutOfCountryMentora.getStudentInformation()
                this.form=res.data.data
            }catch (error){
                this.showErrors(error)
            }
        },
        async onSubmit() {
            const isValid = await this.$refs.formObserver.validate();
            if (isValid) {
                this.isLoading = true
                try {
                    const res = await OutOfCountryMentora.saveRequest(this.form)
                    this.$toast.success(this.$t('Form submitted successfully.'))
                    this.$router.push('/my-mentora-requests/3')
                }catch (error) {
                    this.showErrors(error,this.$refs.formObserver)
                }finally {
                    this.isLoading = false
                }
            }
        }
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

</style>
